import React from 'react'
import { Switch } from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { setValueOptions } from '../../../store/actions/setting';
import { getSideSection, getValueOption, valueOption } from '../../../store/selectors/selectors';
import { IComponent, typeOptions } from '../../../utils/type/dynamic-rendering.interfaces';
//@ts-ignore
import s from './SwitchStandard.module.scss'


let StyledSelect = styled(Switch)` 
    &.ant-switch{
        background-color: #E0E2E6 !important;
    } 
    &.ant-switch-checked{
        background-color: #425D76 !important;
    } 
    &.ant-switch:focus {
        box-shadow: 0 0 0 2px rgb(226 226 226 / 10%) !important;
    } 
    &.ant-switch-checked:focus{
        box-shadow: 0 0 0 2px rgb(66 93 118 / 10%)  !important;
    }
     &.ant-switch .ant-click-animating-node{
        box-shadow: 0 0 0 2px  #425D76 !important;
        -webkit-animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1)  !important;
    }
    @keyframes waveEffect{
        100% {box-shadow: 0 0 0 6px #425d76; !important; }
    }
`;

type additionalStylesT = {
    colorText: string,
    fontSize: string,
}

type SwitchStandardT = {
    id: string
    label: string
    typeOptions: typeOptions
    additionalStyles?: additionalStylesT
    parentKeySection?: unknown
}

export const SwitchStandard = ({ ...props }: SwitchStandardT) => {


    const { id, label, additionalStyles, parentKeySection } = props;
    const dispatch = useDispatch();

    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({ idOptions: id, parentKeySection })(state));
    let tempSectionSide: IComponent[] = useSelector(getSideSection);

    const onChange = (props: any, tempSectionSide: any) => {

        dispatch(setValueOptions({ idParams: id, valueParam: !!!selectValue, parentKeySection: parentKeySection }))
    }


    let styleSwitchName: any;
    if (additionalStyles && additionalStyles['fontSize'] && additionalStyles['colorText']) {
        styleSwitchName = {
            fontSize: additionalStyles['fontSize'],
            color: additionalStyles['colorText'],
        }
    }


    return (
        <div className={s.switch_wrap}>
            <StyledSelect defaultChecked={!!selectValue} onChange={() => onChange(props, tempSectionSide)} />
            <div className={s.switch_name} style={styleSwitchName}>{label}</div>
        </div>
    )
}
